import { Injectable } from '@angular/core';

export enum FilterCode {
  WORKFLOW = 'WfTask',
  TASK = 'Task',
  IN_PROGRESS = 'in_progress',
  DRAFT = 'draft',
  CLOSED = 'closed',
  FAVORITES = 'favorites',
  ALL = 'all'
}
export enum FilterType {
  TYPE = 'type',
  STATUS = 'status',
  OTHER = 'other'
}

export interface SubFilter {
  code: FilterCode;
  name: string;
}

export interface FilterGroup {
  code: FilterType;
  name: string;
  selected: FilterCode;
  subFilters: SubFilter[];
}

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {

  private _showWorkflow = true;
  private _showTask = true;
  private _showAllTasks = false;
  private _showOnlyFavorites = false;
  private _showDoneTasks = true;
  private _showUndoneTasks = true;
  constructor() { }

  get showWorkflow(): boolean {
    return this._showWorkflow;
  }

  set showWorkflow(value: boolean) {
    this._showWorkflow = value;
  }

  get showTask(): boolean {
    return this._showTask;
  }

  set showTask(value: boolean) {
    this._showTask = value;
  }

  get showAllTasks(): boolean {
    return this._showAllTasks;
  }

  set showAllTasks(value: boolean) {
    this._showAllTasks = value;
  }

  get showOnlyFavorites(): boolean {
    return this._showOnlyFavorites;
  }

  set showOnlyFavorites(value: boolean) {
    this._showOnlyFavorites = value;
  }

  get showDoneTasks(): boolean {
    return this._showDoneTasks;
  }

  set showDoneTasks(value: boolean) {
    this._showDoneTasks = value;
  }

  get showUndoneTasks(): boolean {
    return this._showUndoneTasks;
  }

  set showUndoneTasks(value: boolean) {
    this._showUndoneTasks = value;
  }
}
